var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVector(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M57.25 2.33327L19.625 14.8333C-5.66667 23.2916 -5.66667 37.0833 19.625 45.4999L30.7917 49.2083L34.5 60.3749C42.9167 85.6666 56.75 85.6666 65.1667 60.3749L77.7083 22.7916C83.2917 5.9166 74.125 -3.29173 57.25 2.33327ZM58.5833 24.7499L42.75 40.6666C42.125 41.2916 41.3333 41.5833 40.5417 41.5833C39.75 41.5833 38.9583 41.2916 38.3333 40.6666C37.125 39.4583 37.125 37.4583 38.3333 36.2499L54.1667 20.3333C55.375 19.1249 57.375 19.1249 58.5833 20.3333C59.7917 21.5416 59.7917 23.5416 58.5833 24.7499Z",
    fill: "#00C897"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector);
export default __webpack_public_path__ + "static/media/Vector.f3491e31cf8cb32f015337498ca80164.svg";
export { ForwardRef as ReactComponent };